export const AuthDivider = ({ text = 'Ou' }) => (
  <div className="flex items-center gap-4 my-2">
    <div className="flex-1 h-px bg-gray-200" />
    <span className="text-gray-500 text-sm">{text}</span>
    <div className="flex-1 h-px bg-gray-200" />
  </div>
);
